import { inject, Injectable, signal } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { StoredUser } from '@shared/models/login-response.model';
import { Rol } from '@shared/enums/rol.enum';

@Injectable({
  providedIn: 'root',
})
export class RolService {
  private storage = inject(StorageService);
  userRol = signal<Rol | undefined>(undefined);

  constructor() {}

  async getCurrentRol() {
    const user: StoredUser = await this.storage.getItem('user');
    const { perfil } = user;
    this.userRol.set(perfil.idPerfil);
  }
}
